/**
 *
 * @param locale Locale to display the value in
 * @param currency Currency to display the value in
 * @author Malik Bagwala
 * @description ("en-IN","INR") -> "₹"
 */
const getCurrencySymbol = (
  locale: string = "en-IN",
  currency: string = "INR"
) =>
  (0)
    .toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim()

export default getCurrencySymbol
